import React from 'react';
import { LayoutGrid, User, Crown, Settings, Loader2 } from 'lucide-react';
import { useAuthStore, useUIStore, useQuotaStore } from '../../store';
import { Button } from '../ui';
import { isDiscordActivity } from '../../lib/discord-sdk';

export function Header() {
  const { user, isAuthenticated, isLoading } = useAuthStore();
  const { setView } = useUIStore();
  const { quota, hasAccess } = useQuotaStore();
  const isActivity = isDiscordActivity();

  return (
    <header className="sticky top-0 z-50 h-16 flex justify-between items-center px-4 md:px-6 bg-foretell-bg/95 backdrop-blur-xl border-b border-white/10">
      <div
        className="flex items-center gap-3 cursor-pointer"
        onClick={() => setView('channels')}
      >
        <div className="w-9 h-9 bg-foretell-accent rounded-lg flex items-center justify-center font-black text-sm shadow-[0_0_20px_rgba(99,102,241,0.5)] hover:scale-105 active:scale-95 transition-transform">
          F
        </div>
        <div className="hidden sm:block">
          <span className="font-black text-xl tracking-tighter uppercase italic">
            Foretell
          </span>
        </div>
      </div>

      <div className="flex items-center gap-3">
        {isAuthenticated && !hasAccess && quota && (
          <div className="hidden md:flex items-center gap-2 text-xs text-white/40">
            <span className="font-mono">
              {quota.used}/{quota.limit} predictions
            </span>
          </div>
        )}

        {hasAccess && (
          <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-amber-500/10 border border-amber-500/30">
            <Crown size={12} className="text-amber-400" />
            <span className="text-[10px] font-bold text-amber-400 uppercase tracking-wider">
              Premium
            </span>
          </div>
        )}

        {isAuthenticated && user ? (
          <div className="flex items-center gap-3">
            <div className="bg-foretell-accent/20 border border-foretell-accent/40 px-3 py-1.5 rounded-full flex items-center gap-2">
              {user.avatar ? (
                <img
                  src={`https://cdn.discordapp.com/avatars/${user.discordId}/${user.avatar}.png?size=32`}
                  alt=""
                  className="w-5 h-5 rounded-full"
                />
              ) : (
                <div className="w-5 h-5 rounded-full bg-foretell-accent flex items-center justify-center">
                  <User size={12} />
                </div>
              )}
              <span className="text-xs font-bold tracking-wide">
                {user.username}
              </span>
            </div>

            <button
              onClick={() => setView('settings')}
              className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white/60 hover:text-white hover:bg-white/10 transition-all"
            >
              <Settings size={18} />
            </button>
          </div>
        ) : isActivity ? (
          // In Discord Activity, show loading while authenticating
          isLoading ? (
            <div className="flex items-center gap-2 text-white/40">
              <Loader2 size={16} className="animate-spin" />
              <span className="text-xs">Connecting...</span>
            </div>
          ) : null
        ) : (
          <Button
            variant="primary"
            size="sm"
            onClick={() => {
              window.location.href = '/auth/login';
            }}
          >
            Sign In
          </Button>
        )}

        <button
          onClick={() => setView('channels')}
          className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white/60 hover:text-white hover:bg-white/10 transition-all"
        >
          <LayoutGrid size={18} />
        </button>
      </div>
    </header>
  );
}
